import { render, staticRenderFns } from "./addComments.vue?vue&type=template&id=60dabd26&scoped=true&"
import script from "./addComments.vue?vue&type=script&lang=js&"
export * from "./addComments.vue?vue&type=script&lang=js&"
import style0 from "./addComments.vue?vue&type=style&index=0&id=60dabd26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60dabd26",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\demoAdmin\\chuangyueBlockchaimAdmin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60dabd26')) {
      api.createRecord('60dabd26', component.options)
    } else {
      api.reload('60dabd26', component.options)
    }
    module.hot.accept("./addComments.vue?vue&type=template&id=60dabd26&scoped=true&", function () {
      api.rerender('60dabd26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dynamic/communityDynamic/communityComment/components/addComments.vue"
export default component.exports